var enums = Object.create(null);

enums.ACTIVITY_TYPE = {
  PADEL: { name: 'Padel', value: 'PADEL' },
  BADMINTON: { name: 'Badminton', value: 'BADMINTON' },
  SQUASH: { name: 'Squash', value: 'SQUASH' },
  FUTSAL: { name: 'Futsal', value: 'FUTSAL' },
  CANOE: { name: 'Canoë', value: 'CANOE' },
  VTT: { name: 'VTT', value: 'VTT' },
  QUIZZROOM: { name: 'Quizz room', value: 'QUIZZROOM' },
  GROUP_ACTIVITY: { name: 'Groupe', value: 'GROUP_ACTIVITY' }
};

enums.RESOURCE_TYPE = {
  TERRAIN: { name: 'Terrain', pluralName: 'terrains', singularName: 'terrain', value: 'TERRAIN' },
  COURT: { name: 'Court', pluralName: 'courts', singularName: 'court', value: 'COURT' },
  ROOM: { name: 'Salle', pluralName: 'salles', singularName: 'salle', value: 'ROOM' },
  MEETING_ROOM: { name: 'Salle de réunion', pluralName: 'salles de réunion', singularName: 'salle de réunion', value: 'MEETING_ROOM' },
  WELLNESS_ROOM: { name: 'Salle de bien-être', pluralName: 'salles de bien-être', singularName: 'salle de bien-être', value: 'WELLNESS_ROOM' },
  GAME_ROOM: { name: 'Salle de jeu', pluralName: 'salles de jeu', singularName: 'salle de jeu', value: 'GAME_ROOM' },
  GYM: { name: 'Gymnase', pluralName: 'gymnases', singularName: 'gymnase', value: 'GYM' },
  COURSE: { name: 'Parcours', pluralName: 'parcours', singularName: 'parcours', value: 'COURSE' },
  AREA: { name: 'Zone', pluralName: 'zones', singularName: 'zone', value: 'AREA' },
  PARKING: { name: 'Parking', pluralName: 'parkings', singularName: 'parking', value: 'PARKING' }
};

enums.ACCESS_CONTROL_PROVIDER = {
  TTLOCK: 'TTLOCK',
  IPEVIA: 'IPEVIA'
};

enums.TYPE_DURATION = {
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  YEAR: 'year'
};

module.exports = enums;
